import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Utility from "@core/helper/utility";
import Fitralist from "views/pages/donation/Fitra";
import Loader from "@core/helper/Loader";

const Fitra = () => {
  const [donationList, setDonationList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();
  const [role, setRole] = useState("");
  const [status, setStatus] = useState(true);
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const donation = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(donation[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  useEffect(() => {
    const fetchDonationList = () => {
      Loader.isLoading(true);

      const payload = {
        pageNo: pageNumber + 1,
        limit: pageSize,
        orderBy: "DESC",
        type: 2,
      };
      APICall("post", payload, EndPoints.getDonationList)
        .then((response) => {
          const { results, totalCount } = response.data.data;
          if (response.status === 200 && results) {
            setDonationList(results);
            setTotalRecord(totalCount);
          } else {
            setDonationList([]);
          }
        })
        .catch((error) => {
          return error;
        })
        .finally(() => {
          Loader.isLoading(false);
        });
    };
    fetchDonationList();
  }, [pageSize, pageNumber]);

  const enableFitraData = () => {
    const payload = {
      isEnable: !status,
    };
    APICall("post", payload, EndPoints.enableFitra)
      .then(() => {
        Loader.isLoading(false);
      })
      .catch((error) => {
        Loader.isLoading(false);
        return error;
      });
  };
  const setFitraOnOff = () => {
    setStatus((f) => !f);
    enableFitraData();
  };
  useEffect(() => {
    fetchGeneralSetting();
  }, []);
  const fetchGeneralSetting = () => {
    Loader.isLoading(true);

    APICall("get", "", EndPoints.getGeneralSettings)
      .then((response) => {
        const { data } = response.data;
        if (response.status === 200 && data) {
          setStatus(data?.is_fitra);
        } else {
          setStatus([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };
  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Fitra
          </Typography>
        }
        isFitra
        status={status}
        setFitraOnOff={setFitraOnOff}
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <Fitralist
            donationList={donationList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Fitra;
